import { createSelector } from 'reselect';

export const selectMaterialsSlice = state => state.materials;

export const selectMaterials = createSelector(
  selectMaterialsSlice,
  slice => slice.materials
);
export const materialsLoaded = createSelector(
  selectMaterialsSlice,
  slice => slice.materialsLoaded
);
export const selectActiveMaterial = createSelector(
  selectMaterialsSlice,
  slice => slice.activeMaterial
);

export const materialsMeta = createSelector(
  selectMaterialsSlice,
  slice => slice.meta
);
export const materialsFilters = createSelector(
  selectMaterialsSlice,
  slice => slice.filters
);

export const materialCreating = createSelector(
  selectMaterialsSlice,
  slice => slice.isCreating
);
export const materialUpdating = createSelector(
  selectMaterialsSlice,
  slice => slice.isUpdating
);
export const materialDeleting = createSelector(
  selectMaterialsSlice,
  slice => slice.isDeleting
);
export const materialsErrors = createSelector(
  selectMaterialsSlice,
  slice => slice.errors
);
